// extracted by mini-css-extract-plugin
export default {"tab":"Tabs_tab__W-0nz","isSelected":"Tabs_isSelected__3oXhi","utmTabelSection":"Tabs_utmTabelSection__0bdyh"};